import { useState } from 'react';
import { FaXmark } from 'react-icons/fa6';

/* Enter-to-add chip input. Backspace on an empty field removes the last chip.
   Used for the title/description and tags filters in Step 2. */
export default function ChipInput({ value = [], onChange, placeholder }) {
	const [draft, setDraft] = useState('');

	const add = (raw) => {
		const t = raw.trim();
		if (!t) return;
		if (!value.includes(t)) onChange([...value, t]);
		setDraft('');
	};

	const onKeyDown = (e) => {
		if (e.key === 'Enter' || e.key === ',') {
			e.preventDefault();
			add(draft);
		} else if (e.key === 'Backspace' && !draft && value.length) {
			onChange(value.slice(0, -1));
		}
	};

	return (
		<div className="bg-white border-[1.5px] border-slate-200 rounded-xl px-2.5 py-2 flex flex-wrap gap-1.5 items-center focus-within:border-primary focus-within:ring-[3px] focus-within:ring-primary/10 transition">
			{value.map((chip) => (
				<span key={chip} className="inline-flex items-center gap-1.5 bg-primary/10 text-primary text-[12.5px] font-medium pl-2.5 pr-1.5 py-1 rounded-full">
					{chip}
					<button type="button" onClick={() => onChange(value.filter((c) => c !== chip))} className="grid place-items-center hover:text-primary/70">
						<FaXmark size={11} />
					</button>
				</span>
			))}
			<input
				className="flex-1 min-w-[110px] bg-transparent outline-none text-sm text-slate-800 placeholder:text-slate-400 py-1"
				value={draft}
				placeholder={value.length ? '' : placeholder}
				onChange={(e) => setDraft(e.target.value)}
				onKeyDown={onKeyDown}
				onBlur={() => add(draft)}
			/>
		</div>
	);
}
